import { Quote } from "lucide-react";

const testimonials = [
  {
    quote:
      "Adminlaget har gett oss en helt ny lugn i styrelsen. Vi får tydliga rapporter varje månad och slipper jaga kvitton i sista minuten.",
  },
  {
    quote:
      "Professionellt och otroligt lyhört. De känner föreningslivet och förklarar siffrorna på ett sätt som hela styrelsen förstår.",
  },
  {
    quote:
      "Sedan vi anlitade Adminlaget har årsredovisningen blivit en formalitet istället för en mardröm. Rekommenderas varmt.",
  },
];

export const Testimonials = () => {
  return (
    <section id="rekommendationer" className="px-6 lg:px-8 py-24 lg:py-32">
      <div className="max-w-[1280px] mx-auto">
        <div className="max-w-2xl mb-14">
          <span className="text-xs font-medium tracking-widest uppercase text-oak mb-4 block">Kundrekommendationer</span>
          <h2 className="font-display text-4xl md:text-5xl tracking-tight text-balance">
            Föreningar som har sagt <em className="text-oak not-italic">tack och lov</em>.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {testimonials.map((t) => (
            <figure
              key={t.quote}
              className="bg-paper-deep rounded-2xl p-8 ring-1 ring-ink/5 flex flex-col gap-6"
            >
              <Quote className="size-7 text-oak" strokeWidth={1.5} />
              <blockquote className="font-display text-xl leading-snug text-ink text-pretty flex-grow">
                "{t.quote}"
              </blockquote>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};